const parseWindowPath = () => {
  if (!window && !window.location && !window.location.pathname) {
    throw new Error('Window location pathname not available');
  }

  const { pathname } = window.location;

  const paths = pathname.split('/').filter(path => path);

  return {
    match: regex => pathname.match(regex),
    test: regex => regex.test(pathname),
    toArray: () => paths,
    pathCount: paths.length,
  };
};

export default parseWindowPath;
